import { FC } from 'react';
import { VerifyCode } from './components/Form/VerifyCode';
import messageKeybord from '../../../../images/messageKeyboard.svg';
import { Navigate, useLocation } from 'react-router-dom';
import {
    NonAuthorizedContentWithImageLayout,
    RightColumnImage,
} from '@/bo-kit/components/NonAuthorizedContentWithImageLayout';
import { useTranslation } from '@/ui-kit/hooks/useTranslation';
import { Nullable } from '@/ui-kit/types';
import { UserType } from '@/bo-kit/types';

const ResetPasswordCodeVerifyPageResponsive: FC<{ implementation?: 'js' | 'css' }> = ({
    implementation,
}) => {
    const { t } = useTranslation('bo-kit__common');
    const { state } = useLocation() as {
        state: Nullable<{
            email: string;
            password: string;
            confirmPassword: string;
            userType?: UserType;
        }>;
    };
    if (!state) {
        return <Navigate to='/' />;
    }
    return (
        <NonAuthorizedContentWithImageLayout
            title={t('Reset password')}
            implementation={implementation}
            content={
                <VerifyCode
                    email={state.email}
                    password={state.password}
                    confirmPassword={state.confirmPassword}
                    userType={state.userType}
                />
            }
            image={<RightColumnImage src={messageKeybord} />}
        />
    );
};

export default ResetPasswordCodeVerifyPageResponsive;
